import {AnyAction} from 'redux';
import Types from '../../../actions/Types';

import {mergeResponse, QueryState} from '../Response';

import ManualCategory from '../../../../domain/entities/writer/ManualCategory';
import PaginatedResult from '../../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.IndexWriterManualCategoriesSuccess: {
      const result = action.payload as PaginatedResult<ManualCategory>;
      return mergeResponse(state, result);
    }
    default:
      return state;
  }
}
